import { render, staticRenderFns } from "./UploadFilesOnEdit.vue?vue&type=template&id=260d224c&scoped=true&"
import script from "./UploadFilesOnEdit.vue?vue&type=script&lang=js&"
export * from "./UploadFilesOnEdit.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesOnEdit.vue?vue&type=style&index=0&id=260d224c&scoped=true&lang=css&"
import style1 from "./UploadFilesOnEdit.vue?vue&type=style&index=1&id=260d224c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d224c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VChip,VCol,VDialog,VIcon,VSpacer})
